import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import List from '@/assets/common/List/List.vue';
import MachineDetail from '@/components/Machines/MachineDetail/MachineDetail.vue';
import { LoginUser } from "@/types/Component";
import store from '@/assets/common/store/store';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import UnitPrices from '@/components/UnitPrices/UnitPrices.vue';
import { Machine, File, UnitPrice } from '@/types';

export type Item = {
    id: string;
    name: string;
    memo: string;
    isActive: boolean;
}

@Component({
    components: {
        MachineDetail,
        List,
        Thumbnail
    }
})
export default class Machines extends Vue {
    private baseUrl = '/machines';
    private title = '機械';
    private unitPricesTitle = '機械'
    private machines: Machine[] = [];
    private withHidden = false;
    private selectedMachineId = '';
    private isLoading = true;
    private searchText = ''
    private isSpinnerLoading = false
    private unitPrice: any | null = null;
    private selectedItem = "";
    private unEditedMachine!: Machine;
    private machineName = "";
    private machineMemo = "";
    private machinesUnitPrices: UnitPrice[] = [];
    private selectedMachine: Machine = {
        id: '',
        name: '',
        memo: '',
        image_id: '',
        is_hidden: false,
        unit: null
    };
    private selectedMachineImage: File = {
        id: '',
        url: '',
        meta: {
            name: '',
            mime_type: '',
            size: 0
        },
        file: null
    };
    private hiddenMessage = false
    private list: any | null = null
    private isDeleteImage = false
    private deletedMachineImageId = ''
    private checked = false
    private alteredMachines = false;

    @Prop()
    private id!: string;

    @Prop()
    isShowMachinesModal!: boolean

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
    }

    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    @Watch('isShowMachinesModal')
    onShowMachineModalChanged() {
        if (this.isShowMachinesModal) {
            this.getMachines()
        }
    }

    @Watch('isShowMachinesModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    private async getMachines() {
        this.list = null
        this.isLoading = true;
        this.isSpinnerLoading = true
        await this.$apiClient.doRequest('get', `${this.baseUrl}/?with_hidden=${this.withHidden}`).then((ret) => {
            this.isLoading = false;
            this.machines = ret.machines;
            this.list = ret.machines;
            if (this.selectedItem) {
                this.isActive(this.selectedItem);
            }
            this.doSearch();
        });
        this.isSpinnerLoading = false
    }

    private setMachine(machineId: string) {
        this.inputChangedcheck();
        if (this.alteredMachines == false) {
            this.selectedMachineId = machineId;
        }

    }

    setItem(id: string){
        if (id === this.selectedItem) {
            return;
        }
        this.setMachine(id);
    }

    private createMachine() {
        this.inputChangedcheck();
        if (this.alteredMachines == false) {
            this.selectedMachineId = 'create';
            this.changedMachineId()
        }
    }

    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return;
        }
        if (document.body.classList.contains('newsSide')) {
            document.body.classList.remove('newsSide')
        } else {
            document.body.classList.add('newsSide')
        }
    }

    @Watch('searchText')
    private doSearch() {
        const keyword = this.searchText?.trim() ?? '';

        if (!keyword) {
            this.machines = this.list;
            return;
        }
        this.machines = this.list?.filter((item: Item) => item.name.indexOf(this.searchText) > -1)
    }

    private get headerTitle() {
        if (this.selectedMachineId === 'create') {
            return '機械新規作成';
        } else {
            return '機械情報';
        }
    }

    @Watch('isAdmin')
    @Watch("selectedMachineId", { immediate: true })
    private async changedMachineId() {
        this.unitPrice = null;
        this.isDeleteImage = false
        this.deletedMachineImageId = ''
        this.inputChangedcheck();
        if (this.alteredMachines == false) {
        if (document.body.classList.contains('newsSide')) {
            document.body.classList.remove('newsSide')
        }
        if (this.selectedMachineId && this.selectedMachineId != 'create') {
            if (this.isAdmin) {
                await this.$apiClient.doRequest('get', `/admin${this.baseUrl}/${this.selectedMachineId}`).then((res) => {
                    this.selectedMachine = res;
                    this.machineName = res.name;
                    this.machineMemo = res.memo;
                    this.machinesUnitPrices = res.unit;
                    this.unitPrice = UnitPrices;
                });
            } else {
                await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.selectedMachineId}`).then((res) => {
                    this.selectedMachine = res;
                    this.machineName = res.name;
                    this.machineMemo = res.memo;
                    if (this.machinesUnitPrices) {
                        this.machinesUnitPrices.splice(0, this.machinesUnitPrices.length)
                    }
                    this.unitPrice = UnitPrices;
                });
            }

            this.unEditedMachine = this.selectedMachine;

            // 画像情報の取得
            if (this.selectedMachine.image_id) {
                this.$apiClient.doRequest('get', `${this.baseUrl}/${this.selectedMachineId}/image`).then((res) => {
                    this.selectedMachineImage = res;
                });
            } else {
                this.selectedMachineImage.url = ''
                this.selectedMachineImage.id = ''
                this.selectedMachineImage.file = ''
            }
            this.selectedItem = this.selectedMachineId
            this.isActive(this.selectedMachineId);
        }
        else {
            this.selectedMachineImage.url = ''
            this.selectedMachineImage.file = null
            this.selectedMachine.image_id = ''
            this.selectedMachine = {
                id: this.selectedMachineId,
                name: '',
                memo: '',
                image_id: '',
                is_hidden: false,
                unit: null
            };
            this.machineName = '';
            this.machineMemo = '';
            if (this.machinesUnitPrices) {
                this.machinesUnitPrices.splice(0, this.machinesUnitPrices.length);
            }
            this.unitPrice = UnitPrices;

            const refs: any = this.$refs
            if (refs.unitPrices) {
                refs.unitPrices.cleanUnitPrices()
            }
            this.isActive(this.selectedMachineId);
        }
        }
    }

    private isActive(id: string) {
        if (this.machines) {
            this.machines.forEach((item: any) => {
                this.$set(item, 'isActive', item.id === id);
            });
        }
        if (this.list && this.list !== this.machines) {
            this.list.forEach((item: any) => {
                this.$set(item, 'isActive', item.id === id);
            });
        }
    }

    private deleteImage() {
        if (this.selectedMachineImage.id && this.selectedMachineImage.id !== 'create') {
            this.deletedMachineImageId = this.selectedMachineImage.id
        }
        this.selectedMachineImage.url = ''
        this.selectedMachineImage.file = null
        this.selectedMachine.image_id = ''
        this.isDeleteImage = !!this.deletedMachineImageId
        this.inputChanged();
    }

    private syncMachineImage(machineId: string) {
        let request = Promise.resolve()

        if (this.isDeleteImage && this.deletedMachineImageId) {
            request = request
                .then(() => this.$apiClient.doRequest('delete', `${this.baseUrl}/${machineId}/image`))
                .then(() => {
                    this.selectedMachine.image_id = ''
                    this.isDeleteImage = false
                    this.deletedMachineImageId = ''
                })
        }

        if (this.selectedMachineImage.file) {
            request = request.then(() => this.uploadFile(machineId))
        }

        return request
    }

    private onFileChange(e: any) {
        this.inputChanged();
        const files = e.target.files || e.dataTransfer.files;
        if (this.$apiClient.isSizeOver(files)) {
            return;
        }

        if (this.$apiClient.isImageFile(files[0].name)) {
            this.$apiClient.getBase64(files[0]).then((image: any) => {
                this.selectedMachineImage = {
                    id: 'create',
                    url: image.base64 as string,
                    meta: {
                        name: '',
                        mime_type: '',
                        size: 0
                    },
                    file: files[0]
                };
                this.selectedMachine.image_id = this.selectedMachineImage.id
            }).catch(() => {
                window.alert('画像ファイルが読み込めませんでした')
            });
        } else {
            window.alert('画像ファイルを選択してください')
        }
    }

    private submit() {
        let errmsg: string[] = []
        // 名前の入力
        if (!this.machineName.trim()) {
            errmsg.push("機械名を入力してください")
        }
        // 名前の長さ
        if (this.machineName.length > 100) {
            errmsg.push(`機械名は100文字以内で入力してください（現在は${this.machineName.length}文字）`)
        }
        const refs: any = this.$refs
        // メモ
        if (this.machineMemo && this.machineMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.machineMemo.length}文字）`)
        }

        let unitPrices = []
        if (refs.unitPrices) {
            unitPrices = refs.unitPrices.getUnitPrices()
            // 戻ってきた型がstring[]だったらエラーメッセージの配列
            if (unitPrices.length > 0 && typeof unitPrices[0] === 'string') {
                errmsg = errmsg.concat(unitPrices)
            }
        }

        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        const newMachine: Machine = {
            id: this.selectedMachineId,
            name: this.machineName,
            memo: this.machineMemo,
            image_id: this.selectedMachine.image_id,
            is_hidden: this.selectedMachine.is_hidden,
            unit: unitPrices,
        }

        const apiBaseUrl = this.isAdmin ? `/admin${this.baseUrl}` : this.baseUrl

        if (this.selectedMachineId === 'create') {
            const postRequest = this.$apiClient.doRequest('post', apiBaseUrl, newMachine)
            postRequest.then((res) => {
                this.machinesUnitPrices = res.unit;
                return res.id
            }).then(async (id: string) => {
                try {
                    await this.syncMachineImage(id);
                } catch (error) {
                    this.$toasted.error('写真の保存に失敗しました。')
                    return
                }
                this.submitEnd(id);
            }).catch(error => {
                this.$toasted.error('変更に失敗しました。')
            })
        } else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if (!result) {
                return false;
            }
            this.$apiClient.doRequest('put', `${apiBaseUrl}/${this.selectedMachineId}`, newMachine).then((res) => {
                this.machinesUnitPrices = res.unit;
                return res.id
            }).then(async (id: string) => {
                try {
                    await this.syncMachineImage(id);
                } catch (error) {
                    this.$toasted.error('写真の保存に失敗しました。')
                    return
                }
                this.submitEnd(id);
            })
                .catch(error => {
                    this.$toasted.error('変更に失敗しました。')
                })
            this.unEditedMachine = newMachine;
        }
        this.alteredMachines = false;
    }

    private async uploadFile(machineId: string) {
        const res = await this.$apiClient.fileUpload(`${this.baseUrl}/${machineId}/image`, this.selectedMachineImage.file);
        this.selectedMachineId = machineId;
        this.selectedMachineImage.file = null;
        this.selectedMachine.image_id = res.id;
        return res;
    }

    private switchDisplay(isHidden: boolean) {
        if (!window.confirm(`${this.selectedMachine.name}を${!isHidden ? '表示状態に戻します' : '非表示にします'}。よろしいですか？`)) {
            return
        }
        this.selectedMachine.is_hidden = isHidden;
        this.hiddenMessage = true
        this.$apiClient.doRequest('put', `${this.baseUrl}/${this.selectedMachineId}/display?is_hidden=${this.selectedMachine.is_hidden}`).then((res) => {
            this.submitEnd(this.selectedMachineId);
        }).catch(error => {
            this.$toasted.error('変更に失敗しました。')
        })
    }

    private cancelEdit() {
        if (this.alteredMachines) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.alteredMachines = false;
        this.changedMachineId();
    }

    @Emit('submitEnd')
    private submitEnd(machineId: string) {
        if (this.hiddenMessage === false) {
            this.$toasted.success('変更を保存しました。')
        } else {
            this.hiddenMessage = false
            this.$toasted.success(!this.selectedMachine.is_hidden ? '表示に変更しました。' : '非表示に変更しました。')
        }
        this.getMachines()
        return machineId;
    }

    @Emit('inputChanged')
    private inputChanged() {
        if (this.alteredMachines == false) {
            this.alteredMachines = true
        }
    }

    inputChangedcheck() {
        if (this.alteredMachines == true) {
            const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
            if (confirm) {
                this.alteredMachines = false
            }
        }
    }

    closeModal() {
        if (this.alteredMachines && !window.confirm("変更内容を破棄します。よろしいですか？")) {
            return;
        }
        this.$emit('update:isShowMachinesModal', false);
        this.selectedItem = "";
        this.searchText = '';
        this.selectedMachineId = "";
        this.alteredMachines = false
    }

    @Watch('checked')
    private toggleHiddenItems(value: boolean) {
        this.withHidden = value;
        this.getMachines()
    }

}
